export const GET_TAGS = 'GET_TAGS';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_ERROR = 'GET_TAGS_ERROR';
export const RESET_TAGS = 'RESET_TAGS';
export const SET_TAGS_LOADING = 'SET_TAGS_LOADING';
export const SET_TAGS = 'SET_TAGS';
